var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "container container-medium pb-4" },
      [
        _c("Heading", {
          attrs: {
            title:
              _vm.$t("order_title") +
              (_vm.type == "vignette" ? "ERV" : "PJ") +
              _vm.id,
            routeName: "my-orders",
            "heading-class": "heading-medium",
          },
        }),
        _vm.order == null && !_vm.loading
          ? _c("div", { staticClass: "alert alert-danger text-center mt-5" }, [
              _vm._v(" " + _vm._s(_vm.$t("no_order")) + " "),
            ])
          : _vm._e(),
        _vm.order && !_vm.loading
          ? [
              _c(
                "div",
                { staticClass: "order mt-3" },
                [
                  _c("span", { staticClass: "ancillary" }, [
                    _vm._v(_vm._s(_vm.$t("date")) + ":"),
                  ]),
                  _vm._v(" " + _vm._s(_vm.order.date)),
                  _c("br"),
                  _c("span", { staticClass: "ancillary" }, [
                    _vm._v(_vm._s(_vm.$t("product_status")) + ":"),
                  ]),
                  _vm._v(" " + _vm._s(_vm.order.status.name)),
                  _c("br"),
                  _vm.order.payment_type
                    ? [
                        _c("span", { staticClass: "ancillary" }, [
                          _vm._v(
                            _vm._s(_vm.$t("product_payment_method")) + ":"
                          ),
                        ]),
                        _vm._v(" " + _vm._s(_vm.order.payment_type.descriere)),
                        _c("br"),
                      ]
                    : _vm._e(),
                  _c("span", { staticClass: "ancillary" }, [
                    _vm._v(_vm._s(_vm.$t("product_bill_data")) + ":"),
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.order.orderAddress) +
                      ", " +
                      _vm._s(_vm.order.orderCity) +
                      ", " +
                      _vm._s(_vm.order.orderCountry)
                  ),
                  _c("br"),
                  _c("span", { staticClass: "ancillary" }, [
                    _vm._v(_vm._s(_vm.$t("total")) + ":"),
                  ]),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        parseFloat(
                          _vm.order.orderTotalLei + _vm.order.orderTotalLeiSMS
                        ).toFixed(2)
                      ) +
                        " " +
                        _vm._s(
                          _vm.$tc(
                            "currency",
                            parseFloat(
                              _vm.order.orderTotalLei +
                                _vm.order.orderTotalLeiSMS
                            )
                          )
                        )
                    ),
                  ]),
                ],
                2
              ),
              _c("div", { staticClass: "row justify-content-center" }, [
                _c(
                  "div",
                  { staticClass: "col-auto" },
                  [
                    _vm.order.orderInvoice.length
                      ? [
                          _c("div", { staticClass: "bill-btns" }, [
                            _vm.type == "vignette"
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "main-btn mt-3",
                                    attrs: { href: "#", target: "_blank" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.openUrl(
                                          _vm.erv_invoice_url +
                                            _vm.order.orderToken
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("download_bill")))]
                                )
                              : _vm._e(),
                            _vm.type == "toll"
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "main-btn mt-3",
                                    attrs: { href: "#", target: "_blank" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.openUrl(
                                          _vm.toll_invoice_url +
                                            _vm.order.orderToken
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("download_bill")))]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "col-auto" },
                  [
                    _vm.order.orderInvoiceSMS != "" &&
                    _vm.order.orderInvoiceSMS != null
                      ? [
                          _c("div", { staticClass: "bill-btns" }, [
                            _vm.type == "vignette"
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "main-btn mt-3",
                                    attrs: { href: "#", target: "_blank" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.openUrl(
                                          _vm.erv_invoice_sms_url +
                                            _vm.order.orderToken
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("download_bill_sms")))]
                                )
                              : _vm._e(),
                            _vm.type == "toll"
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "main-btn mt-3",
                                    attrs: { href: "#", target: "_blank" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.openUrl(
                                          _vm.toll_invoice_sms_url +
                                            _vm.order.orderToken
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("download_bill_sms")))]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "col-auto" },
                  [
                    _vm.order.hasClientCopy
                      ? [
                          _c("div", { staticClass: "bill-btns" }, [
                            _vm.type == "vignette"
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "main-btn mt-3",
                                    attrs: { href: "#", target: "_blank" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.openUrl(
                                          _vm.erv_client_copy_url +
                                            _vm.order.orderToken
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("download_client_copy"))
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.type == "toll"
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "main-btn mt-3",
                                    attrs: { href: "#", target: "_blank" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.openUrl(
                                          _vm.toll_client_copy_url +
                                            _vm.order.orderToken
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("download_client_copy"))
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
              _vm._l(_vm.order.products, function (product) {
                return product.oProdStatus == 0
                  ? _c(
                      "div",
                      { staticClass: "product mt-3" },
                      [
                        _c("b", [_vm._v(_vm._s(product.oProdProductName))]),
                        _c("br"),
                        _c("span", {
                          staticClass: "ancillary",
                          domProps: {
                            innerHTML: _vm._s(product.category.desc),
                          },
                        }),
                        _c("div", { staticClass: "row mt-2 mb-2" }, [
                          _c("div", { staticClass: "col-6" }, [
                            _c("b", [_vm._v(_vm._s(product.oProdVehicleNo))]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-6 text-right text-truncate" },
                            [_vm._v(" " + _vm._s(product.oProdChasisNo) + " ")]
                          ),
                        ]),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-6" }, [
                            _vm.type == "vignette"
                              ? _c("span", [
                                  _vm._v(
                                    "1 " + _vm._s(_vm.$tc("vignetteWord", 0))
                                  ),
                                ])
                              : _vm._e(),
                            _vm.type == "toll"
                              ? _c("span", [
                                  _vm._v(_vm._s(product.oProdPeriodName)),
                                ])
                              : _vm._e(),
                          ]),
                          _c("div", { staticClass: "col-6" }, [
                            _c("div", { staticClass: "text-right" }, [
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    parseFloat(product.oProdPrice).toFixed(2)
                                  ) +
                                    " " +
                                    _vm._s(
                                      _vm.$tc("currency", product.oProdPrice)
                                    )
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                        _vm.type == "vignette"
                          ? [
                              _c("span", { staticClass: "d-block mt-2" }, [
                                _c("span", { staticClass: "ancillary" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("product_valability")) + ":"
                                  ),
                                ]),
                                _vm._v(" " + _vm._s(product.oProdPeriodName)),
                              ]),
                              product.date_start_availability
                                ? [
                                    _vm._v(
                                      _vm._s(product.date_start_availability)
                                    ),
                                    _c("br"),
                                  ]
                                : _vm._e(),
                              product.date_stop_availability
                                ? [
                                    _vm._v(
                                      _vm._s(product.date_stop_availability)
                                    ),
                                    _c("br"),
                                  ]
                                : _vm._e(),
                            ]
                          : _vm._e(),
                        _vm.type == "toll"
                          ? [
                              _c("span", { staticClass: "d-block mt-2" }, [
                                _c("span", { staticClass: "ancillary" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("product_valability")) + ":"
                                  ),
                                ]),
                                _vm._v(" 1 an"),
                              ]),
                            ]
                          : _vm._e(),
                        _vm.type == "vignette"
                          ? [
                              _c(
                                "span",
                                { staticClass: "ancillary d-block mt-2" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("vignette_series")) + ":"
                                  ),
                                ]
                              ),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    product.oProdVignetteSerie
                                      ? product.oProdVignetteSerie
                                      : "n/a"
                                  ) +
                                  " "
                              ),
                            ]
                          : _vm._e(),
                        _vm.type == "toll"
                          ? [
                              _c(
                                "span",
                                { staticClass: "ancillary d-block mt-2" },
                                [_vm._v(_vm._s(_vm.$t("toll_series")) + ":")]
                              ),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    product.oProdPeajSerie
                                      ? product.oProdPeajSerie
                                      : "n/a"
                                  ) +
                                  " "
                              ),
                            ]
                          : _vm._e(),
                        _c("div", { staticClass: "mt-2" }, [
                          product.oProdSMSConfirmation
                            ? _c("span", { staticClass: "ancillary d-block" }, [
                                _c("span", { staticClass: "far fa-envelope" }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$tc(
                                        "sms_notification_confirmation",
                                        Math.ceil(product.oProdSMSConfirmation),
                                        {
                                          price: _vm.getSmsSettingMessage(
                                            product.oProdSMSConfirmation
                                          ),
                                        }
                                      )
                                    )
                                ),
                              ])
                            : _vm._e(),
                          product.oProdSMSExpiry
                            ? _c("span", { staticClass: "ancillary d-block" }, [
                                _c("span", { staticClass: "far fa-envelope" }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$tc(
                                        "sms_notification_expiry",
                                        Math.ceil(product.oProdSMSExpiry),
                                        {
                                          price: _vm.getSmsSettingMessage(
                                            product.oProdSMSExpiry
                                          ),
                                        }
                                      )
                                    )
                                ),
                              ])
                            : _vm._e(),
                          product.oProdCnairNotify
                            ? _c("span", { staticClass: "ancillary d-block" }, [
                                _c("span", { staticClass: "far fa-envelope" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("cnair_notification_expiry"))
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ],
                      2
                    )
                  : _vm._e()
              }),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }